import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const snackbarColors = {
  info: {
    dark: capitalDesignTokens.foundations.colors.gray800,
    light: capitalDesignTokens.foundations.colors.white
  },
  infoSecondary: {
    dark: capitalDesignTokens.foundations.colors.white,
    light: capitalDesignTokens.foundations.colors.blurple700
  },
  success: {
    dark: capitalDesignTokens.foundations.colors.green700,
    light: capitalDesignTokens.foundations.colors.white
  },
  successSecondary: {
    dark: capitalDesignTokens.foundations.colors.green50,
    light: capitalDesignTokens.foundations.colors.green700
  },
  warning: {
    dark: capitalDesignTokens.foundations.colors.yellow700,
    light: capitalDesignTokens.foundations.colors.white
  },
  warningSecondary: {
    dark: capitalDesignTokens.foundations.colors.yellow50,
    light: capitalDesignTokens.foundations.colors.yellow700
  },
  error: {
    dark: capitalDesignTokens.foundations.colors.red700,
    light: capitalDesignTokens.foundations.colors.white
  },
  errorSecondary: {
    dark: capitalDesignTokens.foundations.colors.red50,
    light: capitalDesignTokens.foundations.colors.red700
  }
};
const MuiSnackbar = {
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const color = ownerState.color || "info";
      const colors = snackbarColors[color] || snackbarColors.info;
      return {
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: 4,
        maxWidth: "520px",
        minWidth: "288px",
        padding: theme.spacing(1),
        paddingLeft: theme.spacing(1.5),
        backgroundColor: colors.dark,
        color: colors.light,
        "& .MuiIconButton-root:hover, & .MuiIconButton-root.Mui-focusVisible": {
          color: theme.palette.text.primary,
          // Only apply these styles if ownerstate.color has a dark background color
          ...(color === "infoSecondary" || color === "success" || color === "warning" || color === "error") && {
            backgroundColor: theme.palette.action.hover,
            color: theme.palette.text.secondary
          }
        }
      };
    }
  }
};
export {
  MuiSnackbar
};
//# sourceMappingURL=MuiSnackbar.js.map
